import React, { useState, useEffect } from 'react';
import { toastr } from 'react-redux-toastr';
import { getLocalDate } from 'utils/helpers';
import Masonry from 'react-masonry-css';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { Actions as appActions } from "reducers/app";

import Pagination from 'components/Pagination';
import ShowNewsModals from "components/ShowNewsModals";


import * as API from 'api/news';
import { push } from 'connected-react-router';

export interface INewsElement {
  id: number;
  name: string;
  description: string;
  image?: string;
  date_add?: string;
}

interface IModal {
  type: string;
  data?: INewsElement;
}

interface IProps {
  goTo: (path: string) => void;
  toggleUIBlocking: (payload: boolean) => void;
}

const NewsPage: React.SFC<IProps & RouteComponentProps<{ page: string }>> = ({
  match,
  goTo,
  toggleUIBlocking,
}) => {
  const {
    params: { page },
  } = match;
  const currentPage = parseInt(page, 10);

  const [modal, showModal] = useState<IModal | undefined>(undefined);

  const hideModal = () => showModal(undefined);

  const [isLoading, setLoading] = useState(false);

  const [news, setNews] = useState<{ data: INewsElement[], pageCount: number, page: number }>({ data: [], pageCount: 0, page: 0 });

  const fetchNews = (page: number) => {
    toggleUIBlocking(true);
    setLoading(true);
    API.getNews(page).then((response: any) => {
      if (response.success) {
        setNews(response);
      } else {
        toastr.error('Ошибка загрузки новостей', response.error);
      }
      toggleUIBlocking(false);
      setLoading(false);
    }).catch(e => {setLoading(false), toggleUIBlocking(false)});
  }

  useEffect(() => {
    fetchNews(currentPage);
  }, [currentPage]);

  return (
    <React.Fragment>
      <div className="container">
        <div className="row pt-md-4">
          <div className="col-12 news-mobile-style">
            <div className="bb mb-4">
              <div className="row d-flex">
                <div className="col-12 col-md-3 col-lg-2 d-flex justify-content-between justify-content-md-start mb-2 mb-md-0">
                  <h2 className="title mb-0">Новости</h2>
                  {/* <div onClick={onAdd} className="news__add" data-toggle='modal' data-target='#newsAdding'>+</div> */}
                </div>
              </div>
            </div>
          </div>
          {!isLoading &&
            <div className="tab-content col-12" id="pills-tabContent">
              <div className="tab-pane fade container no-gutters active show" id="pills-home" role='tabpanel' aria-labelledby='pills-home-tab'>
                <div className="row">
                  {/* <div className="col-lg-6 pr-lg-2"> */}
                  <Masonry
                    breakpointCols={{
                      default: 2,
                      991: 1,
                    }}
                    className="news-masonry-grid"
                    columnClassName="news-masonry-grid_column"
                  >
                    {news.data.map(item => {
                      if (item.image) return (
                        <div key={item.id} className="news__block pb-4 mb-3 ">
                          <img src={item.image} alt="" className="news__block-img mb-2" />
                          <div className="row px-4 align-items-center news-mobile-style">
                            <div onClick={() => showModal({ type: 'showImage', data: item })} className="col-12 col-md-10 cursor-pointer">
                              <h3 className="news__block-title">{item.name}</h3>
                            </div>
                            <div className="col-12 col-md-2 order-first order-md-0 text-md-center"><span>{getLocalDate(item.date_add, 'DD.MM.YYYY')}</span></div>
                            <div className="col-12 col-md-10 pt-1 mb-2"><p className="news__block-text">{item.description.slice(0, 300)}</p></div>
                          </div>
                        </div>
                      );
                      return (
                        <div key={item.id} className="news__block px-4 py-4 mb-3">
                          <div className="row">
                            <div onClick={() => showModal({ type: 'show', data: item })} className="col-12 col-md-10 cursor-pointer">
                              <h3 className="news__block-title">{item.name}</h3>
                            </div>
                            <div className="col-12 col-md-2 order-first order-md-0 text-md-center"><span>{getLocalDate(item.date_add, 'DD.MM.YYYY')}</span></div>
                            <div className="col-12 col-md-10 pt-1 mb-2"><p className="news__block-text">{item.description.slice(0, 300)}</p></div>
                          </div>
                        </div>
                      );
                    })}
                  </Masonry>
                </div>
              </div>
            </div>
          }
        </div>

        {/* Pagination */}
        {!isLoading &&
          <Pagination
            baseUrl={'/home/news/page'}
            page={news.page}
            pageCount={news.pageCount}
          />
        }

      </div>

      {modal && <ShowNewsModals type={modal.type} data={modal.data} onClose={hideModal} />}

    </React.Fragment>
  );
};

const actions = {
  goTo: push,
  toggleUIBlocking: appActions.toggleUIBlocking,
}

export default connect(null, actions)(NewsPage);
